import * as React from 'react';
import { connect } from 'react-redux';

import CampaignAchievementsDefaultItems from './item/CampaignAchievementsDefaultItems';
import CampaignAchievementsItem from './item/CampaignAchievementsItem';
import CampaignAchievementsDefaultStats from './stats/CampaignAchievementsDefaultStats';
import CampaignAchievementsStats from './stats/CampaignAchievementsStats';
import Spinner from 'components/spinner/Spinner';

import {
  fetchCampaignAchievements,
  resetCampaignAchievements
} from 'modules/organizations/reducers/campaignAchievements';

import type { CampaignAchievement, CampaignAchievementMetric } from 'types';

type OwnProps = {
  organizationId: number
};

type StateProps = {
  isLoading: boolean,
  campaignAchievements: Array<CampaignAchievement>,
  campaignStats: Array<CampaignAchievementMetric>
};

type DispatchProps = {
  dispatchFetchCampaignAchievements: (a: number) => void,
  dispatchResetCampaignAchievements: () => void
};

type Props = OwnProps & StateProps & DispatchProps;

class CampaignsAchievements extends React.Component<Props> {
  componentDidMount(): void {
    const { organizationId, dispatchFetchCampaignAchievements } = this.props;

    dispatchFetchCampaignAchievements(organizationId);
  }

  componentWillUnmount(): void {
    const { dispatchResetCampaignAchievements } = this.props;

    dispatchResetCampaignAchievements();
  }

  render(): React.ReactNode {
    const { campaignAchievements, campaignStats, isLoading } = this.props;

    if (isLoading) {
      return (
        <Spinner
          position="inline"
          size="small"
          color="light"
        />
      );
    }

    return (
      <section className="campaign-achievements">
        <section className="campaign-achievements-items">
          {
            campaignAchievements.length === 0 ?
              <CampaignAchievementsDefaultItems /> :
              campaignAchievements.map((achievement) => (
                <CampaignAchievementsItem
                  key={`campaign-achievement-${achievement.type}`}
                  {...achievement}
                />
              ))
          }
        </section>
        {
          campaignStats.length === 0 ?
            <CampaignAchievementsDefaultStats /> :
            <CampaignAchievementsStats stats={campaignStats} />
        }
      </section>
    );
  }
}

const mapStateToProps = ({ campaignAchievements }): StateProps => ({
  campaignAchievements: campaignAchievements.achievements,
  campaignStats: campaignAchievements.stats,
  isLoading: campaignAchievements.isLoading
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchCampaignAchievements: (orgId) => dispatch(fetchCampaignAchievements(orgId)),
  dispatchResetCampaignAchievements: () => dispatch(resetCampaignAchievements())
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignsAchievements);
